export default {
  namespaced: true,
  planning: {
    title: 'Planning | Planning',
    activity_type: 'Scheduled activity type',
    business_division: 'Business division',
    federal_entity: 'Federal entity',
    rems: 'REMS',
    property_name: 'Property name',
    property_type: 'Property type',
    property_types_in_selection: 'Property types in this selection',
    start_date: 'Start date',
    end_date: 'End date',
    start_programming: 'Start programming',
    start_programming_modal_title: 'Start programming',
    start_programming_modal_message: 'Start programming form will be implemented here.',
    activity_type_to_schedule: 'Activity type to schedule',
    form_templates: 'Form templates',
    form_templates_placeholder: 'Select one or more templates…',
    evaluacion_riesgo: 'Risk assessment',
    ejercicio_operativo: 'Operational exercise',
    simulacro: 'Simulation',
    auto_evaluacion_seguridad: 'Security self-assessment',
    selected_units: 'Selected units',
    assigned_to: 'Assigned to',
    no_units_selected: 'Select units above to add them to the table.',
    units_label: 'Units',
    last_sra_date: 'Last SRA date',
    residual_risk_level: 'Residual risk level',
    status: 'Status',
    planning_id: 'Planning ID',
    list_col_assigned_to: 'Assigned to',
    list_col_in_review_by: 'In review by',
    list_col_accepted_cancelled: 'Approved / rejected by',
    list_status_by: 'By {name}',
    last_status_change: 'Last status change',
    status_draft: 'In progress',
    status_review: 'In review',
    status_additional: 'Second approval',
    status_approved: 'Approved',
    status_rejected: 'Rejected',
    status_released: 'Released',
    send_to_review: 'Send to review',
    send_to_approval: 'Send to approval',
    approve: 'Approve',
    reject: 'Reject',
    reject_comment: 'Rejection comment',
    reject_comment_placeholder: 'Reason for rejection (required)',
    send_programming: 'Send programming',
    target_date: 'Target date',
    select_reviewer: 'Select reviewer',
    select_approver: 'Select approver',
    send_second_approval: 'Send to second approval',
    accept_programming: 'Accept programming',
    download_planning: 'Download planning',
    year: 'Year',
    fecha_inicio: 'Start date',
    fecha_fin: 'End date',
    user: 'User',
    comment: 'Comment',
    item_comment_prefix: 'Comment',
    add_comment: 'Add comment',
    comment_placeholder: 'Write a comment',
    add_extra_units: 'Add extra units',
    add_extra_units_placeholder: 'Search and select extra units...',
    status_change_history_title: 'Status change comments history',
    status_change_transition: 'From {from} to {to}',
    toast_planning_title: 'Planning',
    toast_planning_id_line: 'Planning ID: {id}',
    exit: 'Exit',
    scheduled_programming_notification: 'You have scheduled planning',
  },
}
